export const simpleConfigReducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_TAB":
            return {
                ...state,
                selectedTabIndex: action.payload,
            };
        case "PORTAL_FETCHED":
            return {
                ...state,
                portal: { ...action.payload },
                navigationBarOrientation:
                    action.payload.navigationBarOrientation,
                defaultNavigationBarOrientation:
                    action.payload.navigationBarOrientation,
                enableDashboard: action.payload.enableDashboard,
                defaultEnableDashboard: action.payload.enableDashboard,
                enableReporting: action.payload.enableReporting,
                defaultEnableReporting: action.payload.enableReporting,
                isWorkflowEnabled: action.payload.isWorkflowEnabled,
                defaultIsWorkflowEnabled: action.payload.isWorkflowEnabled,
            };
        case "ORIENTATION_CHANGE":
            return {
                ...state,
                navigationBarOrientation: action.payload
            }
        case "ENABLE_DASHBOARD_CHANGE":
            return {
                ...state,
                enableDashboard: action.payload
            }
        case "ENABLE_REPORTING_CHANGE":
            return {
                ...state,
                enableReporting: action.payload
            }
        case "SET_IS_WORKFLOW_ENABLED":
            return {
                ...state,
                isWorkflowEnabled: action.payload
            }
        case "ENTITIES_FETCHED":
            return {
                ...state,
                entities: action.payload,
                entitiesLoaded: true,
            };
        case "DRAG_START":
            return {
                ...state,
                draggedItem: action.payload.draggedItem,
                draggedItemIndex: action.payload.draggedItemIndex
            }
        case "DRAGGED_OVER":
            const entities = [...state.entities];
            const temp = entities[action.payload.draggedOverItemIndex];
            entities[action.payload.draggedOverItemIndex] = state.draggedItem;
            entities[state.draggedItemIndex] = temp;
            return {
                ...state,
                entities,
                draggedOverItem: action.payload.draggedOverItem,
                draggedOverItemIndex: action.payload.draggedOverItemIndex,
                draggedItemIndex: action.payload.draggedOverItemIndex,
            };
        case "DRAG_END":
            return {
                ...state,
                entities: action.payload.map(entity => ({
                    ...entity,
                    isChanged: isChanged(entity)
                }))
            }
        case "SET_MENU_ITEM_DATA_LOADED":
            return {
                ...state,
                isMenuItemsTabLoadingData: false
            };
        case "UPDATE_ENTITY_LABEL": {
            const { index, value } = action.payload;
            state.entities[index].label = value;
            state.entities[index].isChanged = isChanged(state.entities[index]);
            return {
                ...state,
                entities: [...state.entities]
            }
        }
        case "UPDATE_ENTITY_SHOW": {
            const { index, value } = action.payload;
            state.entities[index].show = value;
            state.entities[index].isChanged = isChanged(state.entities[index]);
            return {
                ...state,
                entities: [...state.entities]
            }
        }
        case "TOGGLE_EDIT_ATTRIBUTE_DIALOG":
            return {
                ...state,
                ...action.payload,
                showEditAttributeDialog: !state.showEditAttributeDialog,
            }
        case "TOGGLE_EDIT_LABEL_TRANSLATION_DIALOG":
            return {
                ...state,
                showEditLabelTranslationDialog: !state.showEditLabelTranslationDialog,
            }
        case "UPDATE_ENTITY_LANGUAGES": {
            const newEntities = state.entities.map((entity) => {
                if (entity.menuItemId === action.payload.entityId) {
                    const updatedEntity = {
                        ...entity,
                        languages: action.payload.languages
                    }
                    const isEntityChanged = isChanged(updatedEntity);
                    return {
                        ...updatedEntity,
                        isChanged: isEntityChanged
                    }
                }
                return entity;
            })
            return {
                ...state,
                entities: newEntities
            }
        }
        case "SET_SELECTED_ENTITY": {
            return {
                ...state,
                selectedEntity: action.payload
            }
        }
        case "ENTITY_ATTRIBUTES_LOADED":
            return {
                ...state,
                entityAttributes: action.payload,
                entityAttributesLoading: false
            };
        case "UPDATE_ATTRIBUTE":
            const { index, value } = action.payload;
            const selectedAttributes = [...state.selectedAttributes];
            selectedAttributes[index] = value;
            return {
                ...state,
                selectedAttributes
            }
        case "SAVE_ATTRIBUTES":
            const allEntities = [...state.entities]
            const currentEntity = allEntities.find(
                (entity) =>
                    entity.recentRecordId === state.selectedRecentRecordId
            );
            const newSelectedAttributesValue = state.selectedAttributes.map(attr => ({
                ...attr,
                relationId: attr.relationType === "Has_FirstAttribute" ? action.payload.firstAttributeRelationId : action.payload.secondAttributeRelationId
            }))
            currentEntity.recentRecordAttributes = newSelectedAttributesValue;
            currentEntity.defaultRecentRecordAttributes = newSelectedAttributesValue;
            return {
                ...state,
                entities: allEntities,
                showEditAttributeDialog: false,
                selectedRecentRecordId: "",
                selectedAttributes: [],
                entityAttributesLoading: true,
                entityAttributes: [],
            };
        case "SET_NEW_DEFAULT_VALUES": {
            return {
                ...state,
                ...action.payload
            }
        }
        case "START_SAVING":
            return {
                ...state,
                saving: true
            }
        case "START_PUBLISHING":
            return {
                ...state,
                saving: false,
                publishing: true
            }
        case "PUBLISH_END":
            return {
                ...state,
                publishing: false,
                saveAndPublishCompleted: true,
                publishSuccessful: action.payload.status === "Success",
                publishMessage: action.payload.message,
            };
        case "TARGET_FETCHED":
            return {
                ...state,
                portalTarget: action.payload
            }
        case "HIDE_AFTER_PUBLISH_MESSAGE":
            return {
                ...state,
                publishing: false,
                saveAndPublishCompleted: false,
                publishSuccessful: "",
                publishMessage: ""
            }
        case "REVERT_CHANGES":
            const resetEntities = state.entities
                .sort((a, b) => a.defaultIndex - b.defaultIndex)
                .map((entity, index) => ({
                    ...entity,
                    defaultIndex: index,
                    currentIndex: index,
                    label: entity.defaultLabel,
                    show: entity.defaultShow,
                    isChanged: false
                }))
            return {
                ...state,
                navigationBarOrientation: state.defaultNavigationBarOrientation,
                enableDashboard: state.defaultEnableDashboard,
                enableReporting: state.defaultEnableReporting,
                entities: resetEntities,
                disabled: true
            }
        case "SET_LOADING":
            return {
                ...state,
                loading: action.payload.value
            }
        default:
            return state;
    }
};

function isChanged(entity) {
    const isLabelChanged = entity.defaultLabel !== entity.label;
    const isShowChanged = entity.defaultShow !== entity.show;
    const isIndexChanged = entity.defaultIndex !== entity.currentIndex;
    const languagesChanged = isLanguagesChanged(entity.languages, entity.defaultLanguages);
    return (
        isLabelChanged ||
        isShowChanged ||
        isIndexChanged ||
        languagesChanged
    )
}

function isLanguagesChanged(languages, defaultLanguages) {
    const keys = Object.keys(languages);
    for (const key of keys) {
        if (languages[key] === undefined || defaultLanguages[key] === undefined) {
            debugger;
        }
        if (
            languages[key].label !== defaultLanguages[key].label ||
            languages[key].tooltip !== defaultLanguages[key].tooltip
        ) {
            return true;
        }
    }
    return false;
}